import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ConfigProvider } from "@/context/ConfigContext";
import Layout from "@/components/Layout";
import WarpIntro from "@/pages/WarpIntro";
import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Onboarding from "@/pages/Onboarding";
import Book from "@/pages/Book";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminOnboarding from "@/pages/admin/AdminOnboarding";
import AdminLayout from "@/pages/admin/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App grain-overlay scanlines">
      <ConfigProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/warp" element={<WarpIntro />} />
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/book" element={<Book />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/media" element={<AdminMedia />} />
                <Route path="/admin/contacts" element={<AdminContacts />} />
                <Route path="/admin/onboarding" element={<AdminOnboarding />} />
              </Route>

              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#000",
                border: "1px solid #2a2a2a",
                color: "#fff",
                fontFamily: "JetBrains Mono, monospace",
                borderRadius: 0,
              },
            }}
          />
        </AuthProvider>
      </ConfigProvider>
    </div>
  );
}

export default App;
